import axios from "axios";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { GetSettingDTO } from "../../dto";
import { SettingEnum } from "../../common";

type GetSettingProps = {
  type: SettingEnum;
};

let body: GetSettingDTO;

export async function getSettingAction(props: GetSettingProps) {
  const token = localStorage.getItem("token");

  const params = {
    type: props.type,
  };

  return await axios
    .get(`${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/settings`, {
      headers: {
        "Content-Type": "application/json",
        "app-platform": "cms",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then(async (res) => {
      body = plainToClass(GetSettingDTO, res.data);
      const errors = await validate(body);

      if (errors.length > 0) {
        throw errors;
      }

      return res.data;
    });
}
